import { Directive } from '@angular/core';
import { ElementRef } from '@angular/core';

declare var jQuery: any;

@Directive({
  selector: '[appBoxCollapse]'
})
export class BoxCollapseDirective {
  constructor(el: ElementRef) {
    jQuery(el.nativeElement).boxWidget();
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/directives/boxcollapse/box-collapse.directive.ts